/**
 * @author Maxime Mustarda <maxime@inarix.com>
 * @file LicencesTable.tsx
 * @desc Created on Mon Apr 28 2025 20:44:52
 * @copyright All rights reserved @ Inarix
 */

import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box, Modal, ThemeProvider } from "@mui/material";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";

import themeInarix from "../StylesMuiInarix";
import { selectLocale } from "../../redux/slices/layout";
import {
  focusedLicense,
  selectLicenseLoading,
  selectModalLicense,
} from "../../redux/slices/licenses/licenseList";
import { LicensePacksModal } from "./LicensePacksModal";

import { useLicenseColumns } from "./LicenceColumns";

type LicencesTableParams = {
  apiRef: ReturnType<typeof useGridApiRef>;
};

export const LicencesTable: FC<LicencesTableParams> = ({ apiRef }) => {
  const locale = useSelector(selectLocale);
  const loading = useSelector(selectLicenseLoading);
  const modalLicense = useSelector(selectModalLicense);
  const [t] = useTranslation("global");
  const dispatch = useDispatch();

  const { licenseColumns, licensesRows } = useLicenseColumns(t, dispatch);

  return (
    <Box>
      <ThemeProvider theme={themeInarix(locale)}>
        <div className="container-licenses-table">
          <Box sx={{ height: "58vh", typography: "body1" }}>
            <DataGridPro
              apiRef={apiRef}
              rows={licensesRows}
              columns={licenseColumns}
              rowHeight={70}
              pagination
              disableColumnSelector={true}
              initialState={{
                pagination: { paginationModel: { pageSize: 25 } },
              }}
              loading={loading}
              pageSizeOptions={[25, 50, 100]}
              ignoreDiacritics={true}
            />
          </Box>
        </div>
        <Modal
          open={!!modalLicense}
          onClose={() => dispatch(focusedLicense(""))}
        >
          <LicensePacksModal />
        </Modal>
      </ThemeProvider>
    </Box>
  );
};
